import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { formValidation } from '../functions/Validation';
import Question from '../components/question/Question';
import FormTitle from '../title/FormTitle';
import YouHaveChosen from '../components/youHaveChosen/YouHaveChosen';
import BackToTop from '../components/backToTop/BackToTop';
/*import TagManager from 'react-gtm-module';*/
import { enableQuestionsInSet, showConditionalChildrenChildren, showConditionalChildrenQuestions, showConditionalQuestionsInSet } from '../functions/QuestionEnabling';
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';
import { GetTradesFromQuestion } from '../functions/Trades';
import { answerChildAddressQuestions } from '../functions/AnswerChildAddressQuestions';
import { IsWebReferenceSuffix } from '../functions/Configuration';
import { isAdQuestion } from "../functions/AdQuestions";

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'yourbusiness'
//    },
//    dataLayerName: 'YourBusinessPageDataLayer'
//}

export default function YourBusiness(props: any) {
    const navigate = useNavigate();
    const location = useLocation();

    const [questions, setQuestions] = useState<any[]>([]);
    const [trade, setTrade] = useState<any>();
    const [status, setStatus] = useState<any>();
    const [trades, setTrades] = useState<any[]>([]);
    const [readyToNavigate, setReadyToNavigate] = useState(false);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [initalPageLoad, setInitialPageLoad] = useState(true);
    const [scrollToError, setScrollToError] = useState(false);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const customerDetails = JSON.parse(localStorage.getItem('customerDetails') || "");
    const [displayName, setDisplayName] = useState("");

    let webReference = localStorage.getItem('webReference') || "";
    let nextPage = "Employee details";
    if (localStorage.getItem('shortJourney') === "true") {
        nextPage = "Cover details";
    }
    const pageHeader = IsWebReferenceSuffix(webReference, "RPO") ? "Your details" : "Your business";

    const pageNo: number = 1;

    /*TagManager.dataLayer(tagManagerArgs);*/
    props.setSidebarVisibility(true);

    useEffect(() => {
        props.setCurrentPage(pageNo);
        let storedTrade = localStorage.getItem('trade');
        let storedQuestions = localStorage.getItem('questions');

        if (storedTrade != null) {
            let storedTradeObject = JSON.parse(storedTrade);
            if (storedTradeObject.keywords === "customadded") {
                storedTradeObject.description = "Please select";
            }

            setTrade(storedTradeObject);
            setTrades(GetTradesFromQuestion());
        }

        if (storedQuestions != null) {
            let questionSet = JSON.parse(storedQuestions);
            setQuestions(questionSet);
        }

        setStatus(localStorage.getItem('status'));

        const displayName = !customerDetails ? ""
            : localStorage.getItem("status") === "trader" ? `${customerDetails.forename} ${customerDetails.surname}`
                : customerDetails.surname;
        setDisplayName(displayName);

        setPageLoaded(true);
        setInitialPageLoad(false);
    }, [])

    useEffect(() => {
        if (readyToNavigate) {
            localStorage.setItem('questions', JSON.stringify(questions));
            tracking(Action.SAVE_QUESTIONS);
            if (localStorage.getItem('shortJourney') === "true") {
                navigate("/ChooseCover");
            } else {
                navigate("/EmployeeDetails");
            }

        }
    }, [readyToNavigate])

    useEffect(() => {
        if (scrollToError) {
            document.getElementsByClassName('validation-fail-lbl')[0].scrollIntoView({ behavior: 'smooth' });

            setScrollToError(false);
        }
    }, [scrollToError]);

    useEffect(() => {
        if (!initalPageLoad && trade.keywords !== "customadded") {
            localStorage.setItem('trade', JSON.stringify(trade));
            let updatedQuestions = questions;
            let tradeQuestionID = 0;
            let selectedTradeAnswer = "";
            updatedQuestions.map((question: any) => {
                if (question.questionSetQuestion.text === "What is your main trade?") {
                    selectedTradeAnswer = question.answerList.find((x: { text: string; }) => x.text.toLocaleLowerCase() === trade.description.toLocaleLowerCase()).value;
                    question.answer = selectedTradeAnswer;
                    question.validationFail = false;
                    tradeQuestionID = question.questionSetQuestion.questionID;
                }
            });

            updatedQuestions = enableQuestionsInSet(updatedQuestions, tradeQuestionID);
            setQuestions([...updatedQuestions]);
            var updateAnswerEvent = new CustomEvent("updateAnswer", {
                "detail": { "questionID": tradeQuestionID, "answer": selectedTradeAnswer }
            });

            document.dispatchEvent(updateAnswerEvent);
        }
    }, [trade])

    const nextNavigation = () => {
        let formValid = true;
        try {
            var updatedQuestions = questions.map(question => {
                if (question.page === pageNo && !isAdQuestion(question)) {
                    //if the question has already failed another validation then set the formValid to false
                    if (question.validationFail) {
                        formValid = false;
                    } else {
                        if (formValidation(question)) {
                            question.validationFail = false;
                        } else {
                            formValid = false;
                            question.validationFail = true;
                        }
                    }
                }
                if (question.childInformation != null) {
                    question.childInformation.map((childquestion: any) => {
                        if (childquestion.page === pageNo) {
                            //if the question has already failed another validation then set the formValid to false
                            if (childquestion.validationFail) {
                                formValid = false;
                            } else {
                                if (formValidation(childquestion)) {
                                    childquestion.validationFail = false;
                                } else {
                                    if ((question.questionSetQuestion.childQuestionRepeatMinimum > 0 && childquestion.index > 0) || question.questionSetQuestion.childQuestionRepeatMinimum === 0 || question.questionSetQuestion.childQuestionRepeatMinimum == null) {
                                        formValid = false;
                                        childquestion.validationFail = true;
                                    }
                                }
                            }
                        }
                        return childquestion;
                    });
                }
                return question;
            });
            if (formValid) {
                setReadyToNavigate(true);
            } else {
                setQuestions(updatedQuestions);
                setScrollToError(true);
            }
        }
        catch (e) {

            navigate("/Error", {
                state: {
                    errorTitle: "Your Business page Error",
                    errorMessage: "Unknown error occured while processing 'Your Business' page",
                },
            });
        }
    }

    const showConditionQuestions = (questionID: any, value: any) => {
        let newQuestions = showConditionalQuestionsInSet(questions, questionID, value);
        setQuestions(newQuestions);
    }

    const getIdOfFirstSectionQuestion = (sectionName: string) => {
        var sectionQuestions = questions.filter(x => x.sectionName === sectionName && x.questionSetQuestion.enabled && x.questionSetQuestion.visible && x.page === pageNo);

        // if a section exists with no enabled questions don't show it
        var returnQuestionID = 0;
        if (sectionQuestions.length > 0) {
            returnQuestionID = sectionQuestions[0].questionSetQuestion.questionID;
        }
        return returnQuestionID;
    }

    const setCustomerDetailsAddress = (address: Address) => {
        if (webReference === "CAQSI") {
            let updatedAddressQuestions = questions.map(question => {
                if (question.questionSetQuestion.text.toLowerCase().includes("address line 1")) {
                    question.answer = address.house;
                }
                if (question.questionSetQuestion.text.toLowerCase().includes("address line 2")) {
                    question.answer = address.street;
                }
                if (question.questionSetQuestion.text.toLowerCase().includes("address line 3")) {
                    question.answer = address.locality;
                }
                if (question.questionSetQuestion.text.toLowerCase().includes("town")) {
                    question.answer = address.city;
                }
                if (question.questionSetQuestion.text.toLowerCase().includes("county")) {
                    question.answer = address.county;
                }
                return question;
            });

            setQuestions([...updatedAddressQuestions]);
        }
    }

    const setRPOPropertyAddress = (address: Address) => {
        if (IsWebReferenceSuffix(webReference, "RPO")) {
            let updatedAddressQuestions = questions.map(question => {
                if (question.questionSetQuestion.answerTableName == "USER_MRPO_CVRDTPRP") {
                    if (question.questionSetQuestion.answerFieldName == "AddOne") {
                        question.answer = address.house;
                    }
                    if (question.questionSetQuestion.answerFieldName == "AddTwo") {
                        question.answer = address.street;
                    }
                    if (question.questionSetQuestion.answerFieldName == "AddThree") {
                        question.answer = address.locality;
                    }
                    if (question.questionSetQuestion.answerFieldName == "Town") {
                        question.answer = address.city;
                    }
                    if (question.questionSetQuestion.answerFieldName == "County") {
                        question.answer = address.county;
                    }
                }
                return question;
            });

            setQuestions([...updatedAddressQuestions]);
        }
    }

    const setChildResponseAddress = (address: Address, questionPosition: string) => {
        if ((questionPosition.split('|').length - 1) === 1) {
            let newQuestions = answerChildAddressQuestions(questions, address, questionPosition)

            setQuestions(newQuestions);

        }
    }

    const setTradeForDeviceDetection = (trade: any) => {
        fetch(`${apiBaseUrl}customer/SetTradeForDeviceDetection?deviceDetectionID=${localStorage.getItem('deviceDetectionID')}&trade=${trade.description}`, {
        })
            .then(response => {
                return response.json();
            })
            .catch((error) => {

            });
    }

    const updateTrade = (updatedTrade: any) => {
        setTradeForDeviceDetection(updatedTrade);
        setTrade(updatedTrade);
    }

    const setIndividualCustomerDetails = (question: any) => {
        if (question.questionSetQuestion.text.toLowerCase() === "what is your main trade?" && question.answer !== '') {
            let dropdownItem = question.answerList.filter((x: { value: any; }) => x.value === question.answer);
            trade.description = dropdownItem[0].text;
            setTrade(trade);
            setTradeForDeviceDetection(trade);
            localStorage.setItem('trade', JSON.stringify(trade));
        }

        if (question.questionSetQuestion.text.toLowerCase() === "what year was the business established?" || question.questionSetQuestion.text.toLowerCase() === "what year were you established?") {

            let dropdownItem = question.answerList.find((x: { value: any; }) => x.value === question.answer);
            if (dropdownItem !== undefined) {
                let establishedYear = parseInt(dropdownItem.text);
                let currentYear = new Date().getFullYear();
                let yearsEstablished = currentYear - establishedYear;
                let yrsQuestion = questions.find((x: { questionSetQuestion: any; }) => x.questionSetQuestion.text.toLowerCase() === "yrs");
                let yrsQuestionID = yrsQuestion.questionSetQuestion.questionID;
                var updatedQuestions = questions.map(question => {
                    if (question.questionSetQuestion.questionID === yrsQuestionID) {
                        question.answer = yearsEstablished.toString();
                    }
                    return question;
                });
                let newQuestions = enableQuestionsInSet(updatedQuestions, yrsQuestionID);
                setQuestions(newQuestions);
            }
        }
    }

    const enableQuestions = (questionID: number) => {
        let newQuestions = enableQuestionsInSet(questions, questionID);
        setQuestions(newQuestions);
    }

    const resetRelatedQuestionsValidationOnAnswerChange = (questionID: number) => {
    }

    const showConditionalChildren = (parentQuestionID: number, value: any, firstChildQuestionID: number, firstChildIndex: number, secondChildQuestionID?: number, secondChildIndex?: number) => {
        if (secondChildQuestionID != null && secondChildIndex != null) {
            let newQuestions = showConditionalChildrenChildren(questions, parseInt(parentQuestionID.toString()), parseInt(firstChildQuestionID.toString()), parseInt(secondChildQuestionID.toString()), parseInt(firstChildIndex.toString()), parseInt(secondChildIndex.toString()), value);
            setQuestions(newQuestions);
        } else {
            let newQuestions = showConditionalChildrenQuestions(questions, parseInt(parentQuestionID.toString()), parseInt(firstChildQuestionID.toString()), parseInt(firstChildIndex.toString()), value);
            setQuestions(newQuestions);
        }
    }

    const resetCoverValidation = () => { }

    const getPageStatement = (displayName: string) => {
        return IsWebReferenceSuffix(webReference, "RPO") ?
            <p>To allow us to provide the best cover we can, we need to know a little bit more about you and your property.</p>
            :
            <p>To allow us to provide the best cover we can, we need to know a little bit more about {displayName} and your day to day activity. Don&rsquo;t worry if you don&rsquo;t have the exact information to hand, your best estimate is good for now.</p>;
    }

    return (
        <>
            {pageLoaded &&
                <>
                <div className="form-container">
                    <FormTitle title={pageHeader} />
                    {displayName !== "" &&
                        getPageStatement(displayName)}
                    {questions.map((question, index) => {
                        if (isAdQuestion(question)) {
                            return null;
                        }
                        return (
                            <div key={index}>
                                {question.questionSetQuestion.questionID === getIdOfFirstSectionQuestion(question.sectionName) && question.page === pageNo && question.questionSetQuestion.visible &&
                                    <div className="section-header" key={question.questionSetQuestion.questionID + "_" + question.questionSetQuestion.sectionID}>{question.sectionName}</div>
                                }
                                <Question question={question} key={question.questionSetQuestion.questionID} showConditionQuestions={showConditionQuestions} enableQuestions={enableQuestions} resetRelatedQuestionsValidationOnAnswerChange={resetRelatedQuestionsValidationOnAnswerChange} setCustomerDetailsAddress={setCustomerDetailsAddress} page={pageNo} setIndividualCustomerDetails={setIndividualCustomerDetails} showConditionalChildren={showConditionalChildren} questionIdPosition={question.questionSetQuestion.questionID + "-" + question.index} setChildResponseAddress={setChildResponseAddress} resetCoverValidation={resetCoverValidation} setRPOPropertyAddress={setRPOPropertyAddress} />
                            </div>)
                        }
                        )}
                    </div>
                    <div className="btn-container">
                        <button className="btn primary" onClick={() => nextNavigation()}>Next: {nextPage}</button>
                    </div>
                    <BackToTop />
                </>
            }
        </>
    )
}